import Ajax from './ajax.js'
import config from '@/config/index.js'
export default {
    install(Vue, router) {
        let ajax = new Ajax(Vue, config, router)
        Vue.prototype.$ajax = (name, params, options) => {
            return ajax.sendRequest(name, params, options)
        }
    }
}

